import { render, staticRenderFns } from "./ArrowsControl.vue?vue&type=template&id=deabf68c&scoped=true&"
import script from "./ArrowsControl.vue?vue&type=script&lang=js&"
export * from "./ArrowsControl.vue?vue&type=script&lang=js&"
import style0 from "./ArrowsControl.vue?vue&type=style&index=0&id=deabf68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deabf68c",
  null
  
)

export default component.exports